import React from 'react';
import {ContextMessage} from '@epic-mw/localization';
import {FormGroup} from './Form.styles';
import {TextField} from 'epic-ue-components';

interface Properties {
    name: string;
    value: string;
    maxLength?: number;
    isValid?: boolean;
    fieldId?: string;
    onChange: any;
    onBlur?: any;
    validationText?: string;
    validationClass?: string;
    activeClass?: string;
    labelText: string;
    messageProp?: string;
    onKeyPress?: any;
    readonly?: boolean;
}

export const EmailInput = (props: Properties): JSX.Element => {
    const {
        name,
        value,
        maxLength,
        isValid,
        fieldId,
        onChange,
        onBlur,
        onKeyPress,
        validationText,
        labelText,
        messageProp,
        readonly
    } = props;

    let labelInnerText;

    if (labelText === null && messageProp) {
        labelInnerText = <ContextMessage code={messageProp} />;
    } else {
        labelInnerText = labelText;
    }

    return (
        <FormGroup className={`form-group`}>
            <TextField
                type="text"
                id={fieldId}
                name={name}
                label={labelInnerText}
                value={value}
                helperText={!isValid ? validationText : ''}
                error={!isValid}
                inputProps={{
                    ['data-id']: fieldId,
                    ['data-name']: name,
                    maxLength
                }}
                onChange={onChange}
                onKeyPress={onKeyPress}
                onBlur={onBlur}
                fullWidth
                disabled={readonly}
            />
        </FormGroup>
    );
};
